const MIN_NAME_LENGTH = 2
const MIN_UNIQUE_FIRST_LENGTH = 4
const MIN_COMPACT_MATCH_LENGTH = 6

function normalizeName(value) {
	return String(value || '')
		.trim()
		.toLowerCase()
		.split(/\s+/)
		.filter(Boolean)
		.join(' ')
}

function compactName(value) {
	return normalizeName(value).replace(/\s+/g, '')
}

/**
 * Precomputes normalized name fields for transcript matching.
 * Rebuild when the counselor student roster changes.
 */
export function buildStudentNameIndex(students = []) {
	const entries = []
	const firstNameToIds = new Map()

	if (!Array.isArray(students)) {
		return { entries, firstNameToIds }
	}

	for (const student of students) {
		const id = String(student?.id ?? '').trim()
		if (!id) continue

		const fullNorm = normalizeName(student?.name)
		if (fullNorm.length < MIN_NAME_LENGTH) continue

		const parts = fullNorm.split(' ')
		const firstNorm = parts[0] || ''
		const lastNorm = parts.length > 1 ? parts[parts.length - 1] : ''
		const fullCompact = compactName(fullNorm)

		entries.push({
			id,
			fullNorm,
			fullCompact,
			firstNorm,
			lastNorm,
			tokenCount: parts.length,
		})

		if (firstNorm.length >= MIN_UNIQUE_FIRST_LENGTH) {
			const existing = firstNameToIds.get(firstNorm)
			if (existing) {
				existing.push(id)
			} else {
				firstNameToIds.set(firstNorm, [id])
			}
		}
	}

	return { entries, firstNameToIds }
}

export function isStudentNameIndex(value) {
	return Boolean(value && Array.isArray(value.entries) && value.firstNameToIds instanceof Map)
}

export {
	MIN_NAME_LENGTH,
	MIN_UNIQUE_FIRST_LENGTH,
	MIN_COMPACT_MATCH_LENGTH,
	normalizeName,
	compactName,
}
